import LocalSeoPage from '@/pages/local/components/LocalSeoPage';
import { aracruzBombas } from '@/mocks/localSeoData';

export default function RecuperacaoBombasHidraulicasAracruz() {
  return <LocalSeoPage data={aracruzBombas} />;
}